import { isDevMode } from '@angular/core';
import { constants } from 'os';

export class Constants {
    // Insight Dev
    public static INSIGHT_SERVER_URL = 'https://c5iop.mpsinsight.com/';
   // public static INSIGHT_SERVER_URL = 'http://localhost:8080/';
    // public static INSIGHT_SERVER_URL = 'https://c5.mpsinsight.com/';
    // public static INSIGHT_SERVER_URL = 'http://10.50.8.198:8080/';
    // Static 
    // public static INSIGHT_SERVER_URL = 'hsttps://c5qa.mpsinsight.com/';

    // Insight Prod
    public static BASE_URL = Constants.INSIGHT_SERVER_URL + 'insightc5api/services/';

    // Login URL
    public static OLD_LOGIN_URL = Constants.BASE_URL + 'login';

    // Reset URL
    public static RESET_PASSWORD_URL = Constants.BASE_URL + 'forgetpassword/getsecquestion';
    public static UPDATE_PASSWORD_URL = Constants.BASE_URL + 'forgetpassword/updatepassword';

    // Dashbaord URL
    public static FULLTXT_URL = Constants.BASE_URL + 'summary/fulltext';
    public static PAGEVIEW_URL = Constants.BASE_URL + 'summary/pageview';
    public static ANALYTICAL_DROPDOWN_VALUE = Constants.BASE_URL + 'product/applicableproducts';
    public static PROCESSINGSTATUS_URL = Constants.BASE_URL + 'summary/processingstatus';
    public static ACCOUNTSSUMMARY_URL = Constants.BASE_URL + 'summary/accountsummary';
    public static PROGRESSGRAPH_URL = Constants.BASE_URL + 'summary/fullTextProcessGraph';
    public static UNIDENTIFIED_IP_DETAIL_URL = Constants.BASE_URL + 'summary/unidentifiedipdetail';
    public static LICENCE_DENIAL_URL = Constants.BASE_URL + 'summary/licencedenial';
    public static HIGHEST_IP_DETAIL_URL = Constants.BASE_URL + 'summary/highestipdetail';
    public static FEED_ARCHIVE_URL = Constants.BASE_URL + 'processing/feedarchive';
    public static FEED_C5_ARCHIVE_URL = Constants.BASE_URL + 'processing/c5feedarchivelist';
    public static FEED_C5_ARCHIVE_DATE=Constants.BASE_URL+'processing/c5feedate'

    public static IN_PROCESSING_QA_MANUALROLLBACK = Constants.BASE_URL + 'processing/qa/manualrollbacklist';
    public static IN_PUSHLIVE_ALL = Constants.BASE_URL + 'processing/qa/pushlive';
    public static IN_QAMONTHS = Constants.BASE_URL + 'processing/qa/qamonthlist';

    public static IN_ROLLBACK_ALL = Constants.BASE_URL + 'processing/qa/rollback';
    public static IN_ROLLBACK_DELETE_URL = Constants.BASE_URL + 'processing/qa/manualrollback';

    public static ANALYSIS_GRAPH_URL = Constants.BASE_URL + 'product/analysisgraph';
    public static PROGRESSDETAIL_URL = Constants.BASE_URL + 'product/progressdetail';
    public static PROGRESSDETAIL_ASC_DES_URL = Constants.BASE_URL + 'product/progressdetailmore';
    public static NO_LICENSE_GRAPH_URL = Constants.BASE_URL + 'counter5dash/nolicense';
    public static LIMIT_EXCEEDED_GRAPH_URL = Constants.BASE_URL +
        'counter5dash/limitexceeded';
    public static COUNTER5_ANALYSIS_GRAPH_DRILLDOWN_URL = Constants.BASE_URL +
        'counter5dash/requestanalysis';
    public static COUNTER5_SITE_SUMMARY = Constants.BASE_URL + 'counter5dash/sitesummary';
    public static COUNTER5_NEW_SITESUMMARY_GRAPH_URL = Constants.BASE_URL + 'counter5dash/sitesummaryc5'

    // Account URL
    public static ACC_GROUP_TYPE_URL = Constants.BASE_URL + 'accounts/grouptype';
    // Processing APIs
    public static PR_REPORT_LIST_URL = Constants.BASE_URL + 'publisherreport/reportlisttemp';
    public static PR_REPORT_YEAR_URL = Constants.BASE_URL + 'publisherreport/pubyearlist';
    public static TK_DYNAMIC_REPORT_LIST_URL = Constants.BASE_URL + 'dynamic/dynamicreportlist';
    public static PS_CONFIG_REPORT_LIST_URL = Constants.BASE_URL + 'configurereports/libreports';

    // SUPPORT APIs
    public static TK_CONTACT_US_TYPE_OF_QUERIES_URL = Constants.BASE_URL + 'supportservices/contactus/typesofqueries';
    public static TK_CONTACT_US_SEND_QUERIES_MAIL_URL = Constants.BASE_URL + 'supportservices/contactus/sendquerymail';
    public static TK_SYSTEM_LOG_PROCESSING_SUMMARY = Constants.BASE_URL + 'supportservices/systemlog/processingsummary';
    public static TK_SYSTEM_LOG_LOGS_REPORT = Constants.BASE_URL + 'supportservices/systemlog/getsystemlogs';
    public static TK_SYSTEM_LOG_REPORT_STATUS_URL = Constants.BASE_URL + 'supportservices/systemlog/reportstatus';

    // MANAGE USER APIs
    public static TK_MANAGE_USER_CREATE_USER_URL = Constants.BASE_URL + 'manageuser/createuser';

    // SETTINGS APIs
    // manage Favs Api
    public static TK_SETTINGS_SEARCH_ACCOUNT_URL = Constants.BASE_URL + 'setting/searchaccounts';
    public static TK_SETTINGS_ADD_FAVORITES_ACCOUNT_URL = Constants.BASE_URL + 'setting/accountfavoriteaddlist';
    public static TK_SETTINGS_REMOVE_FAVORITES_ACCOUNT_URL = Constants.BASE_URL + 'setting/removefavorite';
    // manage Email Alerts Api
    public static TK_SETTING_EMAIL_ALERT_URL = Constants.BASE_URL + 'setting/emailalertscreen';
    public static ADD_NEW_ALERT_URL = Constants.BASE_URL + 'setting/addemailalert';
    public static REMOVE_NEW_ALERT_URL = Constants.BASE_URL + 'setting/removeemailalert';
    // Library config Api
    public static TK_LIBRARY_CONFIG_URL = Constants.BASE_URL + 'setting/libraryconfigsetting';
    public static TK_LIBRARY_CONFIG_DATA = Constants.BASE_URL + 'setting/updatelibrarysetting';
    public static TK_CONFIG_LIBRARY_CONFIG_DATA = Constants.BASE_URL +
        'configurereports/updatelibreports';
    // Push Live Api
    public static TK_UPDATE_PUSH_LIVE_URL = Constants.BASE_URL + 'setting/updatepushlivesetting';
    public static TK_SET_PUSH_LIVE_URL = Constants.BASE_URL + 'setting/pushlivesetting';

    // For display heading
    public static HIGHEST_IP_DETAILS_MESSAGE = 'Top %d Highest Accessing IPs ';
    public static UNIDENTIFIED_IP_DETAIL_MESSAGE = 'Top %d Unidentified Full-Text Requests';
    public static LICENCE_DENIAL_MESSAGE = 'Identified Licence Denial';
    // public static IN_WEB_ACCOUNTS_GROUPTYPE_URL = Constants.BASE_URL + 'accounts/grouptype';
    public static IN_WEB_ACCOUNTS_LIST_ATOZ_URL = Constants.BASE_URL + 'accounts/accountlistatoz';
    public static IN_WEB_ACCOUNTS_DETAILS_URL = Constants.BASE_URL + 'accounts/accountdetails';
    public static IN_WEB_SEARCH_BY_ALPHABET_URL = Constants.BASE_URL + 'accounts/searchbyalphabet';
    public static IN_WEB_SEARCH_FOR_BOOK_JOURNAL_URL = Constants.BASE_URL + 'pubreport5/publisherbookreportall';
    public static IN_WEB_SEARCH_FOR_BOOK_JOURNAL_BY_ALPHABET_URL = Constants.BASE_URL + 'pubreport5/publisherbookreportforalphabet';
    public static IN_WEB_ACCOUNT_SEARCH_URL = Constants.BASE_URL + 'accounts/searchresult';
    public static IN_WEB_ACCOUNT_LIB_ADMIN_URL = Constants.BASE_URL + 'accounts/searchlibuseroradmin';
    public static IN_PROCESSING_DYNAMIC_REPORT_URL = Constants.BASE_URL + 'dynamic/dynamicreportjson';
    public static IN_DYNAMIC_REPORT_EMAIL_URL = Constants.BASE_URL +
        'dynamic/maildynamicreport';
    public static IN_COUNTER5_DYNAMIC_REPORT_EMAIL_URL = Constants.BASE_URL +
        'counter5/mailreport';
    public static IN_COUNTER5_DYNAMIC_REPORT_URL = Constants.BASE_URL + 'counter5/reportlist';
    public static IN_COUNTER5_DYNAMIC_REPORT_URLR51 = Constants.BASE_URL + 'counter5/reportlist_r51';
    public static IN_COUNTER5_DYNAMIC_REPORT_DETAILS_URL = Constants.BASE_URL + 'counter5/reportattributedetail';
    public static IN_COUNTER5_DYNAMIC_PREVIEW_REPORT_DETAILS_URL = Constants.BASE_URL + 'counter5/counter5reportjson';
    public static IN_COUNTER5_DYNAMIC_PREVIEW_REPORT_DETAILS_URL51 = Constants.BASE_URL + 'counter5/counter5reportjson51';
    public static IN_COUNTER5_PUBLISHER_PREVIEW_REPORT_DETAILS_URL = Constants.BASE_URL + 'pubreport5/reportjson';
    public static IN_COUNTER5_PUBLISHER_REPORT_DETAILS_URL = Constants.BASE_URL + 'pubreport5/reportlist';
    public static IN_COUNTER5_DOWNLOAD_REPORT_DETAILS_URL = Constants.BASE_URL + 'download/counter5reports';
    public static IN_COUNTER5_DOWNLOAD_REPORT_DETAILS_URL51 = Constants.BASE_URL + 'download/counter5reports51';
    public static IN_COUNTER5_DOWNLOAD_PUB_REPORT_DETAILS_URL = Constants.BASE_URL + 'download/counter5pubreports';
    public static IN_AUTO_SEARCH_SUGGEST_URL = Constants.BASE_URL + 'accounts/publisheraccountlistfromcache';
    public static IN_COUNTER5_DYNAMIC_REPORT_DETAILS_URL51 = Constants.BASE_URL + 'counter5/reportattributedetail51';
    public static IN_WEB_ACCOUNTS_PUBLISHER_ACCOUNT = // https://alpha.mpsinsight.com/Compass-API/accounts/publisheraccountlistfromcache`;
        Constants.BASE_URL + 'accounts/publisheraccountlistfromcache';
    public static IN_WEB_ACCOUNT_LIST_URL = Constants.BASE_URL + 'processing/qa/browseaccountlist';
    public static IN_PUB_FAVORITES_URL = Constants.BASE_URL + 'accounts/user/pubfavorites';
    public static IN_PUB_MY_FAVORITES_URL = Constants.BASE_URL + 'accounts/user/myfavorites';
    public static IN_QA_SEARCH_URL = Constants.BASE_URL + 'accounts/searchresult';
    public static IN_QA_ACCOUNTS_GENERATED_REPORTS_URL = Constants.BASE_URL + 'accounts/generatedreports';
    public static IN_QA_LIVE_REPORTS_URL = Constants.BASE_URL + 'accounts/reportstatus';
    public static IN_PUB_USER_LIST_URL = Constants.BASE_URL + 'manageuser/getpubuserlist';
    public static IN_USER_LIST_URL = Constants.BASE_URL + 'manageuser/getUserList';
    public static IN_LIB_LINKED_ACCOUNT_LIST_URL = Constants.BASE_URL + 'manageuser/searchaccountsbyuser';
    public static IN_USER_DELETE_USER_URL = Constants.BASE_URL + 'manageuser/deleteuser';
    public static IN_UNLINK_ACCOUNTS_URL = Constants.BASE_URL + 'accounts/unlinkedusers';
    public static IN_USER_UNLINK_ACCOUNT_URL = Constants.BASE_URL + 'manageuser/removeAccountUser'
    public static IN_GET_All_ROLE_URL = Constants.BASE_URL + 'manageuser/getallroles';
    public static IN_LIB_TO_LINK_ACCOUNT_URL = Constants.BASE_URL + 'manageuser/linkAccountUser';
    public static IN_CREATE_USER_URL = Constants.BASE_URL + 'manageuser/createuser';
    public static IN_EDIT_USER_URL = Constants.BASE_URL + 'manageuser/edituser';
    public static IN_GET_EDIT_USER_DETAILS_URL = Constants.BASE_URL + 'managelibrary/editLibUserScreen';
    public static IN_PUBLISHER_REPORT_REPORTLIST_URL = Constants.BASE_URL + 'publisherreport/reportlist';
    public static IN_PUBLISHER_REPORT_YEAR_URL = Constants.BASE_URL + 'publisherreport/pubyearlist';
    public static IN_ACCOUNTS_QA_YEAR_URL = Constants.BASE_URL + 'accounts/accountyearlist';

    public static IN_PUBLISHER_REPORT_GETJOURNAL_URL = Constants.BASE_URL + 'publisherreport/searchbyalphabet';
    public static IN_AUTO_SEARCH_BOOK_JOURNAL_URL = Constants.BASE_URL + 'pubreport5/publisherbookreportall';

    public static IN_PUBLISHER_REPORT_ALBHABET_URL = Constants.BASE_URL + 'publisherreport/getjournals';
    public static IN_PUBLISHER_REPORT_SEARCHJOURNAL_URL = Constants.BASE_URL + 'publisherreport/searchjournals';
    public static IN_PUBLISHER_REPORT_LOCATION_URL = Constants.BASE_URL + 'publisherreport/location';
    public static IN_ACCOUNTS_USERSEARCH_URL = Constants.BASE_URL + 'accounts/searchusersbyaccount';
    public static IN_ACCOUNTS_SEARCHUNLINKED_USER_URL = Constants.BASE_URL + 'accounts/searchunlinkedusers';
    public static IN_SUSHI_PARTNER_URL = Constants.BASE_URL + 'sushipartner/accountsushipartner';
    public static IN_FAV_UNFAV_ACCOUNT_URL = Constants.BASE_URL + 'accounts/checkaccountfav';
    public static IN_PARENT_ACCOUNT_URL = Constants.BASE_URL + 'accountparentchild/getparents';
    public static IN_CHILD_ACCOUNT_URL = Constants.BASE_URL + 'accountparentchild/getchild';
    public static IN_ACCOUNT_LIVE_DETAIL = Constants.BASE_URL + 'libLogin/accountlivedetail';
    public static IN_CREATE_MANAGE_SUSHI_USER_LIST_URL = Constants.BASE_URL + 'sushipartner/getsushilist';
    public static IN_EMAIL_ALERTS_URL = Constants.BASE_URL + 'manageuser/emailalert';
    public static IN_CREATE_MANAGE_SUSHI_CREATE_USER_URL = Constants.BASE_URL + 'sushipartner/createSushiPartner';
    public static IN_EDIT_SUSHI_USER_URL = Constants.BASE_URL + 'sushipartner/editPartnerScreen';
    public static IN_UPDATE_SUSHI_PARTNER_URL = Constants.BASE_URL + 'sushipartner/editsushipartner';
    public static IN_CREATE_MANAGE_SUSHI_GET_DELETE_USER_DETAILS_URL = Constants.BASE_URL + 'sushipartner/deletesushipartner';

    public static IN_LIBRARY_GRAPH_HEADER = Constants.BASE_URL + 'lib/graphheader';
    public static IN_LIBRARY_TREND_GRAPH = Constants.BASE_URL + 'libLogin/trendGraph';
    public static IN_LIBRARY_CHILD_ACCOUNT = Constants.BASE_URL + 'lib/childaccount';
    public static IN_EXPORT_ACCOUNT_LIST = Constants.BASE_URL + 'accounts/exportaccountlist';
    public static IN_TOP_SEARCHED_ACCOUNT_LIST = Constants.BASE_URL + 'accounts/topsearchaccountlist';
    public static IN_INST_STATS_ACCOUNT_LIST = Constants.BASE_URL + 'processing/c5institutionstautslist';

    public static IN_ERROR_LOG = Constants.BASE_URL + 'sendEmail';

    // Original Link  'https://api.mps-think.com/Compass-API/SearchSalesReport/annualSaleDownlaod';

    public static IN_PUBLISHER_REPORT_DOWNLOAD = Constants.BASE_URL + 'download/';
    public static IN_USER_TECHNOLOGY_ANALYSIS = Constants.BASE_URL + 'product/usertechanalysis';
    public static getInsightAPIURL() {
        if (isDevMode()) {
            return 'https://alpha.mpsinsight.com/';
        } else {
            return 'https://insight.mps-think.com/';
        }
    }

    // used in Insight Dashboard HTML
    getHigheshIPDetailUrl(): string {
        return Constants.HIGHEST_IP_DETAIL_URL;
    }

    getUnidentifiedIPDetailUrl(): string {
        return Constants.UNIDENTIFIED_IP_DETAIL_URL;
    }

    getProgressDetail_Url(): string {
        return Constants.PROGRESSDETAIL_URL;
    }

    getLicenceDenialUrl(): string {
        return Constants.LICENCE_DENIAL_URL;
    }

    getHigheshIPDetailMsg(): string {
        return Constants.HIGHEST_IP_DETAILS_MESSAGE;
    }

    getUnidentifiedIPDetailMsg(): string {
        return Constants.UNIDENTIFIED_IP_DETAIL_MESSAGE;
    }

    getLicenceDenialMsg(): string {
        return Constants.LICENCE_DENIAL_MESSAGE;
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/shared/constant.ts